import { useAppRouter } from '../../useAppRouter';
import { getPublicRuntimeConfig } from '../../../libs/init/getPublicRuntimeConfig';

export function useIsPageAppletRoute(): boolean {
  const { pathname } = useAppRouter();
  const { paths } = getPublicRuntimeConfig();

  return pathname === paths.extensionsPageAppletProvider;
}
